import { useContext, useEffect } from "react";
import { CartContext } from "../../../../Context/CartContext";
import { Fragment } from "react";
import { getShippingCostFromSettings } from "../../libs/useMarketplaceShippingFees";
import "./CartPayment.css";

const CartItemPayment = ({ shippingMethod = "door", shippingSettings, paymentMethod = "paystack" }) => {
  const { cartItems, totalCart } = useContext(CartContext);
  const shippingCost = getShippingCostFromSettings(shippingSettings, shippingMethod);
  const grandTotal = totalCart + shippingCost;

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
    localStorage.setItem("totalCart", totalCart);
  }, [cartItems, totalCart]);

  const formatNgn = (amount) =>
    amount.toLocaleString("en-US", { style: "currency", currency: "NGN" });

  const shippingLabel =
    shippingMethod === "pickup"
      ? shippingSettings?.pickupLabel || "Pickup"
      : shippingSettings?.doorLabel || "Door delivery";

  return (
    <Fragment>
      <div className="cart-payment-wrapper">
        <div className="cart-list-payment">
          <div className="cart-card-payment">
            {cartItems.map((cartItem) => (
              <div className="cart-check-payment" key={`${cartItem._id}-${cartItem.selectedSize || ""}`}>
                <div className="cart-payment-con">
                  <div className="cart-payment-span-1">
                    <img src={cartItem.images?.[0]} alt={cartItem.name} />
                    <h3>
                      {cartItem.name}
                      {cartItem.selectedSize ? ` (${cartItem.selectedSize})` : ""}
                    </h3>
                  </div>
                  <div className="cart-payment-span-2">
                    <p>
                      {cartItem.quantity && cartItem.price
                        ? formatNgn(cartItem.quantity * cartItem.price)
                        : formatNgn(0)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-payment-sumarry">
            <div className="order-payment-card">
              <span>
                <p>Subtotal</p>
                <h3>{totalCart ? formatNgn(totalCart) : ""}</h3>
              </span>
              <span>
                <p>Shipping ({shippingLabel})</p>
                <h3>{formatNgn(shippingCost)}</h3>
              </span>
              <span>
                <p>Total</p>
                <h3>{formatNgn(grandTotal)}</h3>
              </span>
              {paymentMethod === "pay_on_delivery" && (
                <p className="cart-payment-pod-note">
                  You&apos;ll pay <strong>{formatNgn(grandTotal)}</strong> when your order is delivered.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CartItemPayment;
